import { DashboardOutlined } from "@ant-design/icons";
import { DashboardPerformanceReport } from "components/Report/DashboardPerformanceReport/DashboardPerformanceReport";
import { DashboardShell } from "components/Report/UI/Dashboard";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { PermissionEnum } from "types/enums";
import { createTenantFileRoute } from "utils/createTenantFileRoute";
import { getDashboardHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/")({
    component: DashboardPage,
    staticData: {
        permissions: [PermissionEnum.DashboardView],
        showInSideMenu: true,
        label: "pages.dashboard.title",
        icon: <DashboardOutlined />,
        sort: 1,
        showBreadcrumbsBar: false,
    },
});

function DashboardPage() {
    return (
        <TenantPage headerNavigationItems={getDashboardHeaderItems}>
            <DashboardPerformanceReport />
            <DashboardShell />
        </TenantPage>
    );
}
